import React, {memo, ReactNode} from 'react';

import {gt} from 'app/utils/i18n';

import {BaseAvatar} from './BaseAvatar';
import {AvatarTooltipsProps, getTooltipContent} from './tooltips';

import {BasicRoleSerializedType} from 'sweet-types';

interface Props extends AvatarTooltipsProps {
  role: BasicRoleSerializedType;
  multiple?: boolean;
  link?: boolean;
  displayBlock?: boolean;
  className?: string;
  style?: any;
  small?: boolean;
}

export const RoleAvatar = memo<Props>(
  function RoleAvatar({
    role,
    className = '',
    multiple,
    tooltipPlacement,
    tooltipTitle,
    style,
    displayBlock,
    link,
    small,
  }: Props) {
    const roleTitle = getRoleTitle(role);
    return (
      <BaseAvatar
        title={roleTitle}
        displayBlock={displayBlock}
        multiple={multiple}
        className={className}
        style={style}
        small={small}
        link={link === true ? role.html_url : undefined}
        tooltipPlacement={tooltipPlacement}
        tooltipContent={getTooltipContent(
          getRoleTooltipItemName(roleTitle),
          tooltipTitle
        )}
      />
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.role.name === nextProps.role.name &&
      prevProps.role.name === nextProps.role.name
    );
  }
);

export function getRoleTitle(role: BasicRoleSerializedType): string {
  return role.name;
}

export function getRoleTooltipItemName(title: string | ReactNode): ReactNode {
  return (
    <span>
      {title} <span className="font-italic">{gt('role')}</span>
    </span>
  );
}
